export const DRIVE_FILE_SCOPE = 'https://www.googleapis.com/auth/drive.file';
export const DRIVE_SCOPE = 'https://www.googleapis.com/auth/drive.readonly';
export const DRIVE_FULL_SCOPE = 'https://www.googleapis.com/auth/drive';
export const CALENDAR_SCOPE = 'https://www.googleapis.com/auth/calendar';
export const GOOGLE_SHEET_SCOPE = 'https://www.googleapis.com/auth/spreadsheets';
export const INIT_SCOPE = 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive.install';
export const GSUITE_ADMIN_GROUP = 'https://www.googleapis.com/auth/admin.directory.group.readonly';
